const BannerSkeleton = () => {
    return (
        <div className="banner-skeleton skeleton" />
    );
};

export default BannerSkeleton;
